import React from 'react'

import { LoadingPane, Spinner } from './AssetsBreakdown.styles'

const Loading = () => (
  <LoadingPane>
    <Spinner size={16} />
  </LoadingPane>
)

export default Loading
